import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/deleteIcon.svg";
import { ReactComponent as MapIcon } from "../../../Assets/Icons/MapIcon.svg";
import { ReactComponent as MailIcon } from "../../../Assets/Icons/mailIcon.svg";
import { ReactComponent as WebIcon } from "../../../Assets/Icons/webIcon.svg";
import { ReactComponent as UserIcon } from "../../../Assets/Icons/userIcon.svg";
import { ReactComponent as PhoneIcon } from "../../../Assets/Icons/phoneIcon.svg";
import "../../common/OfferList/offerList.scss";
import defaultCategoryIcon from "../../../Assets/Icons/subCategoryIcon.svg";
import Confirmation from "../../common/OfferList/Confirmation";
import StoresTable from "./StoresTable";

var settings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  // dotsClass: "slick-dots",
  // customPaging: function() {
  //   return (
  //     <div style={customDotStyle}></div>
  //   );
  // }
};

const PopupContent = ({ merchantDetails, onDelete, onApprove, onDecline, onReviewStatus, onShowReviewModal, onChangeLogo }) => {
  console.log("PopupContent received merchantDetails:", merchantDetails);
  const role = useSelector((state) => state?.authReducer?.tokenData?.user?.role);
  const {
    address,
    businessName,
    category,
    contactPersonName,
    contactPersonNumber,
    logo,
    user,
    website,
    _id,
    status,
    description,
    stores,
    // Fallback fields for in-process merchants
    email,
    phoneNumber,
    phone,
    contact,
    mobile,
    location,
    businessAddress,
    business_address,
    websiteUrl,
    url,
    contactName,
    name
  } = merchantDetails || {}; // Safety check

  // Derived values to handle both data structures
  const displayEmail = user?.email || email || "N/A";
  const displayContact = contactPersonNumber || phoneNumber || phone || contact || mobile || "N/A";
  const displayAddress = address || location || businessAddress || business_address || "N/A";
  const displayWebsite = website || websiteUrl || url || "N/A";
  const displayContactName = contactPersonName || contactName || name || user?.name || "N/A";

  if (!merchantDetails) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <div className="loader"></div>
        <p className="mt-4 text-[#767676] font-poppins text-[15px]">Loading merchant details...</p>
      </div>
    );
  }

  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className="max-h-[500px] overflow-y-auto w-full flex flex-col gap-2 justify-between font-poppins"
    >
      <div className="w-full flex justify-between items-center mb-4 gap-6">
        <div className="flex justify-start items-center gap-4 flex-1 min-w-0">
          <div className="relative flex-shrink-0">
            {(function () {
              const l = logo;
              const isMissing = !l || (typeof l === 'string' && l.trim() === '');
              const src = (function () {
                if (isMissing) return require("../../../Assets/Images/PersonBlue.svg").default;
                const isAbs = typeof l === 'string' && /^(https?:)?\/\//i.test(l);
                return isAbs ? l : `${process.env.REACT_APP_S3_URL || ''}${l}`;
              })();
              if (isMissing) {
                return (
                  <>
                    <div className="w-[60px] h-[60px] md:w-[72px] md:h-[72px] rounded-full bg-[#E6F7FF] border border-[#00ADEF33] flex items-center justify-center flex-shrink-0">
                      <img src={src} alt="merchantLogo" className="w-[38px] h-[38px] md:w-[44px] md:h-[44px] object-contain" />
                    </div>
                    {(role === "admin" || role === "ADMIN") && onChangeLogo && (
                      <button
                        onClick={() => onChangeLogo(merchantDetails)}
                        className="absolute bottom-0 right-0 w-[20px] h-[20px] md:w-[24px] md:h-[24px] rounded-full bg-[#00ADEF] flex items-center justify-center border-2 border-white shadow-md hover:bg-[#0088CC] transition-colors"
                        title="Change Logo"
                      >
                        <img
                          src={require("../../../Assets/Icons/editIcon.svg").default}
                          alt="Edit"
                          className="w-[10px] h-[10px] md:w-[12px] md:h-[12px] filter brightness-0 invert"
                        />
                      </button>
                    )}
                  </>
                );
              }
              return (
                <>
                  <div
                    className="w-[60px] h-[60px] md:w-[72px] md:h-[72px] rounded-full bg-white border border-[#00ADEF33] flex items-center justify-center flex-shrink-0 overflow-hidden"
                  >
                    <img
                      src={src}
                      alt="merchantLogo"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  {(role === "admin" || role === "ADMIN") && onChangeLogo && (
                    <button
                      onClick={() => onChangeLogo(merchantDetails)}
                      className="absolute bottom-0 right-0 w-[20px] h-[20px] md:w-[24px] md:h-[24px] rounded-full bg-[#00ADEF] flex items-center justify-center border-2 border-white shadow-md hover:bg-[#0088CC] transition-colors"
                      title="Change Logo"
                    >
                      <img
                        src={require("../../../Assets/Icons/editIcon.svg").default}
                        alt="Edit"
                        className="w-[10px] h-[10px] md:w-[12px] md:h-[12px] filter brightness-0 invert"
                      />
                    </button>
                  )}
                </>
              );
            })()}
          </div>

          <h1 className="font-[600] text-[16px] md:text-[18px] lg:text-[20px] truncate max-w-[280px] md:max-w-[350px]">
            {businessName}
          </h1>
        </div>
        <div className="flex justify-between items-center gap-4">
          <div className="flex items-center gap-3 flex-shrink-0">
            {/* {(status === "approved" || status === "declined") && (role === "admin" || role === "ADMIN") && (
              <button
                type="button"
                onClick={() => onShowReviewModal && onShowReviewModal()}
                className="px-3 py-1 text-[12px] font-[500] text-[#00ADEF] border border-[#00ADEF] rounded-[4px] hover:bg-[#00ADEF] hover:text-white transition-colors whitespace-nowrap"
              >
                Review Status
              </button>
            )} */}
            <Confirmation status={status} />
          </div>
          {status === "pending" && (
            <button
              type="button"
              title="Delete Merchant"
              onClick={() => onDelete && onDelete(_id)}
              className="p-2 rounded hover:bg-[#F5F5F5] focus:outline-none"
            >
              <DeleteIcon />
            </button>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-6 gap-y-3">
        {Array.isArray(category) && category.length > 0 && category.map((c, index) => {
          const title = typeof c === 'string' ? c : (c?.title || '');

          // Check if title looks like a Mongo ID (24 hex chars)
          // If it is, we skip rendering it because the user doesn't want to see IDs
          if (/^[0-9a-fA-F]{24}$/.test(title)) {
            return null;
          }

          const imgPath = typeof c === 'string' ? (c?.image || '') : (c?.image || '');
          const src = (function () {
            const url = imgPath;
            const isAbsolute = typeof url === 'string' && /^(https?:)?\/\//i.test(url);
            if (isAbsolute && url) return url;
            const baseUrl = process.env.REACT_APP_ICON_URL || '';
            if (url) {
              const needsSlash = baseUrl && !baseUrl.endsWith('/') && url && !url.startsWith('/');
              return `${baseUrl}${needsSlash ? '/' : ''}${url}`;
            }
            return defaultCategoryIcon;
          })();
          return (
            <div key={`merchant-cat-${index}-${title}`} className="flex justify-start items-center gap-3">
              <img src={src} alt="categoryImg" className="w-[22px] h-[22px] filter-blue" />
              <h3 className="text-[#303030] text-[14px]">{title}</h3>
            </div>
          );
        })}
      </div>
      {/* <div className="flex justify-start items-center flex-wrap gap-2 mt-2">
        {subCategory.map((option, index) => (
          <button
            key={index}
            //   onClick={() => handleOptionClick(option)}
            className={`px-4 py-1.5 rounded-full text-[13px] font-[500] bg-[#F1F1F1] text-[#767676]
              `}
          >
            {option?.title}
          </button>
        ))}
      </div> */}
      <div className="grid grid-cols-2 gap-4 mt-2">
        <div className="flex gap-2 mt-1">
          <MailIcon />
          <p className="text-[14px] font-[400] text-[#767676]">{displayEmail}</p>
        </div>
        <div className="flex gap-2 mt-1">
          <WebIcon />
          <p className="text-[14px] font-[400] text-[#767676]">{displayWebsite}</p>
        </div>
        <div className="flex justify-start items-center gap-2 mt-1 text-[14px] font-[400] text-[#767676]">
          <UserIcon />
          <p>{displayContactName}</p>
        </div>
        <div className="flex justify-start items-center gap-2 mt-1 text-[14px] font-[400] text-[#767676]">
          <PhoneIcon />
          <p>{displayContact}</p>
        </div>
      </div>
      <div className="flex mt-4 justify-start items-center gap-2 text-[14px] font-[400] text-[#767676]">
        <MapIcon />
        <h3>{displayAddress}</h3>
      </div>
      {/* <div className="flex flex-col gap-2 mt-4 text-[14px] font-[400] text-[#303030]">
        {tempLocations?.map((location, index) => (
          <div key={index} className="flex gap-2">
            <MapIcon />
            <h3>{location?.name}</h3>
          </div>
        ))}
      </div> */}

      {stores?.length > 0 && <div className="w-full flex flex-col mt-4 gap-3 items-start font-poppins">
        <h2 className="text-[16px] font-[500] text-[#000000] text-start">
          Other Stores <span className="text-[#8C8C8C]">({stores?.length})</span>
        </h2>
        <StoresTable stores={stores} />
      </div>}

      <div className="w-full flex flex-col mt-4 gap-1 items-start font-poppins">
        <h2 className="text-[16px] font-[500] text-[#000000] text-start">
          Description:
        </h2>
        <p className="w-full text-start text-[14px] font-[400] text-[#767676]">
          {description || "No description available"}
        </p>
      </div>
      {status === "pending" && (
        <div className="w-full flex justify-end items-center gap-3 mt-6">
          <button
            type="button"
            onClick={() => onDecline && onDecline(_id)}
            className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => onApprove && onApprove(_id)}
            className="bg-[#00ADEF] text-white h-[38px] whitespace-nowrap px-6 py-1 rounded-[6px]"
          >
            Approve
          </button>
        </div>
      )}


    </div>
  );
};

export default PopupContent;
